import React from "react";

const socialLinks = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/inventralabs",
    className: "instagram",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="1.2" />
      </svg>
    )
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/109334935/",
    className: "linkedin",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M5 8.8h3.2V19H5z" />
        <circle cx="6.6" cy="5.7" r="1.8" />
        <path d="M10.3 8.8h3.1v1.4c.5-.8 1.5-1.7 3.1-1.7 3.3 0 3.9 2.1 3.9 4.9V19h-3.2v-5c0-1.2 0-2.7-1.7-2.7s-1.9 1.3-1.9 2.6V19h-3.2V8.8z" />
      </svg>
    )
  }
];

const Contact = () => {
  const lat = 13.034252607978864;
  const lng = 77.6957914526738;
  const mapsLink = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
  const mapEmbedUrl = `https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`;

  return (
    <section className="contact-page">
      <div className="contact-heading">
        <h2>Contact Us</h2>
        <p>Reach us for product, service, and partnership conversations.</p>
      </div>

      <div className="contact-grid">
        <article className="contact-card">
          <h3>Contact Info</h3>
          <p>
            <strong>Address</strong>
            #35, 7th Cross, RKM Layout Phase 3 Road, Margondanahalli,
            Bengaluru, Karnataka - 560036
          </p>
          <p>
            <strong>Email</strong>
            <a href="mailto:contact@inventralabs.com">contact@inventralabs.com</a>
          </p>
        </article>

        <article className="contact-card">
          <h3>Social Media</h3>
          <p>Connect with Inventra Labs through our official channels.</p>
          <div className="social-icon-row">
            {socialLinks.map((link) => (
              <a
                key={link.label}
                className={`social-icon-link ${link.className}`}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.label}
                title={link.label}
              >
                {link.icon}
              </a>
            ))}
          </div>
        </article>

        <article className="contact-card contact-map-card">
          <h3>Location</h3>
          <a className="map-frame-link" href={mapsLink} target="_blank" rel="noopener noreferrer">
            <iframe
              title="RKM Layout Phase 3 Location"
              src={mapEmbedUrl}
              loading="lazy"
              allowFullScreen=""
            />
          </a>
          <p className="map-note">Click the map to open in Google Maps.</p>
        </article>
      </div>
    </section>
  );
};

export default Contact;
